import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { getUsers } from "../../redux/userSpeaker/userSpeakerSlice";
import useDebounce from "../../hook/useDebounce";
import { toast } from "react-toastify";
import { assignStaffToSponsor } from "../../redux/sponsors/sponsorSlice";
import { Icon } from "@iconify/react";

const AssignSponsorComponent = ({ sponsorId }) => {
    const dispatch = useDispatch();

    const { users = [] } = useSelector((state) => state.speaker);

    const [selectedUsers, setSelectedUsers] = useState([]);
    const [userIds, setUserIds] = useState([]);
    const [confirmAssign, setConfirmAssign] = useState(false);

    const [search, setSearch] = useState("");
    const debouncedSearch = useDebounce(search, 800);

    useEffect(() => {
        dispatch(getUsers({ search: debouncedSearch }));
    }, [debouncedSearch]);

    const userOptions = users.map((u) => ({
        value: u.id,
        label: `${u.fullName} (${u.email}) (${u.Role?.name})`,
    }));

    const handleOpenConfirm = () => {
        if (!userIds.length) {
            return toast.error("Please select users");
        }
        setConfirmAssign(true);
    };

    const handleConfirmAssign = async () => {
        try {
            await dispatch(
                assignStaffToSponsor({
                    sponsorId,
                    userIds,
                })
            ).unwrap();

            toast.success("Users assigned successfully");
            setSelectedUsers([]);
            setUserIds([]);
            setConfirmAssign(false);
        } catch (err) {
            toast.error(err?.message || "Failed to assign");
        }
    };

    return (
        <div className="assign-location-wrapper">

            <div className="card shadow-sm border-0 rounded-4 p-20 mb-20">
                <div className="d-flex justify-content-between align-items-center mb-16">
                    <div>
                        <h5 className="fw-bold mb-4">Assign Staff</h5>
                        <span className="text-muted small">
                            Select users to assign to this sponsor
                        </span>
                    </div>
                </div>

                <div style={{ maxWidth: 500 }}>
                    <Select
                        isMulti
                        options={userOptions}
                        value={selectedUsers}
                        onChange={(selected) => {
                            setSelectedUsers(selected || []);
                            setUserIds(selected ? selected.map((s) => s.value) : []);
                        }}
                        onInputChange={(value) => setSearch(value)}
                        placeholder="Search & select users..."
                    />
                </div>

                {selectedUsers.length > 0 && (
                    <div className="d-flex flex-wrap gap-12 mt-16">
                        {selectedUsers.map((u) => (
                            <div key={u.value} className="location-chip">
                                <Icon icon="mdi:account" width="16" />
                                <span className="mx-8">{u.label}</span>
                            </div>
                        ))}
                    </div>
                )}

                <div className="mt-20">
                    <button className="btn btn-primary" onClick={handleOpenConfirm}>
                        Assign Selected Users
                    </button>
                </div>
            </div>

            {confirmAssign && (
                <div className="custom-modal">
                    <div className="modal-content-box">

                        <div className="modal-header">
                            <h6>Assign Users</h6>
                            <Icon
                                icon="mdi:close"
                                className="cursor-pointer"
                                onClick={() => setConfirmAssign(false)}
                            />
                        </div>

                        <div className="modal-body text-center">
                            <Icon icon="mdi:account-check" width="50" color="#4CAF50" />
                            <p className="mt-10">
                                Are you sure you want to assign these users?
                            </p>

                            <div className="mt-12">
                                {selectedUsers.map((u) => (
                                    <div key={u.value} className="fw-semibold">
                                        {u.label}
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                className="btn btn-light"
                                onClick={() => setConfirmAssign(false)}
                            >
                                Cancel
                            </button>

                            <button
                                className="btn btn-primary"
                                onClick={handleConfirmAssign}
                            >
                                Confirm
                            </button>
                        </div>

                    </div>
                </div>
            )}
        </div>
    );
};

export default AssignSponsorComponent;